import { httpRequest } from '@calendly/http-tools'

import { setUser } from 'common'

export const updateAvailabilityFormView = (view) => (dispatch) => {
  dispatch(setUser({ availability_form_view: view }))

  httpRequest({
    url: '/api/account/settings',
    method: 'PATCH',
    data: {
      user_availability_form_view: view
    }
  })
}
